<!-- Logged out this page is a public, footer-linked marketing surface: it gets the same
     app-portal-navbar as home/products. Signed in, it relies on the app shell's own
     header (title resolved from MenuConfigService.publicPages) instead of a page-local
     copy — see AppComponent.hideAppShell$/showPublicNav$. -->
@if (!isAuthenticated) {
<app-portal-navbar></app-portal-navbar>
}

<ion-content #pageContent [scrollEvents]="true">
  <div class="ds-page" [class.ds-page--public]="!isAuthenticated" [class.ds-page--shell]="isAuthenticated">

    <!-- Hero -->
    <div class="ds-hero">
      <div class="ds-hero-icon">
        <ion-icon name="lock-closed-outline"></ion-icon>
      </div>
      <h1>{{ 'mainauth.privacy.title' | translate }}</h1>
      <p class="ds-meta">{{ 'mainauth.privacy.meta' | translate }}</p>
    </div>

    <!-- Section index + cards. Two columns from 1100px up, stacked below. -->
    <div class="ds-layout">
      <app-legal-toc class="ds-toc" [sections]="tocSections" [content]="pageContent"
        [scrollOffset]="isAuthenticated ? 112 : 80"></app-legal-toc>

    <!-- Sections -->
    <div class="ds-sections">

      <!-- Product-specific annex notes. Always rendered (no more ?product= selector —
           see docs/KONZEPT-Produkt-Rechtsseiten.md): a reader following any product's
           link, or a bare /datenschutz link, sees the whole document. -->
      @for (p of annexProducts; track p) {
      <div class="ds-card ds-card--product" [id]="p">
        <div class="ds-card-header">
          <div class="ds-num"><ion-icon name="pricetag-outline"></ion-icon></div>
          <div class="ds-card-title">{{ ('mainauth.privacy.product.' + p + '.title') | translate }}</div>
        </div>
        <p>{{ ('mainauth.privacy.product.' + p + '.body') | translate }}</p>
      </div>
      }

      <div class="ds-card" id="ds-s01">
        <div class="ds-card-header">
          <div class="ds-num">01</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s01Title' | translate }}</div>
        </div>
        <p>
          <strong>Gastro Management Oberbillig</strong><br>
          Erik Alexander Oberbillig<br>
          {{ 'mainauth.privacy.address' | translate }}<br>
          <a href="mailto:management@gastro-management.ch">management&#64;gastro-management.ch</a>
        </p>
        <p>{{ 'mainauth.privacy.s01DataRequests' | translate }} <a href="mailto:privacy@gastro-management.ch">privacy&#64;gastro-management.ch</a></p>
        <!-- Art. 27 GDPR / UK GDPR representatives — rendered once appointed (legal-entity.ts). -->
        @if (hasEuRep) {
        <p><strong>{{ 'mainauth.privacy.s01EuRepLabel' | translate }}</strong> {{ euRep.name }}, {{ euRep.address }}, <a [href]="'mailto:' + euRep.email">{{ euRep.email }}</a></p>
        }
        @if (hasUkRep) {
        <p><strong>{{ 'mainauth.privacy.s01UkRepLabel' | translate }}</strong> {{ ukRep.name }}, {{ ukRep.address }}, <a [href]="'mailto:' + ukRep.email">{{ ukRep.email }}</a></p>
        }
        <p>{{ 'mainauth.privacy.s01NoDpo' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s02">
        <div class="ds-card-header">
          <div class="ds-num">02</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s02Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s02Intro' | translate }}</p>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s02ControllerLabel' | translate }}</strong> {{ 'mainauth.privacy.s02ControllerText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s02ProcessorLabel' | translate }}</strong> {{ 'mainauth.privacy.s02ProcessorText' | translate }}</li>
        </ul>
        <p>{{ 'mainauth.privacy.s02Scope' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s03">
        <div class="ds-card-header">
          <div class="ds-num">03</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s03Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s03Intro' | translate }}</p>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s03AccountLabel' | translate }}</strong> {{ 'mainauth.privacy.s03AccountText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s03BusinessLabel' | translate }}</strong> {{ 'mainauth.privacy.s03BusinessText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s03EmployeeLabel' | translate }}</strong> {{ 'mainauth.privacy.s03EmployeeText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s03ReservationLabel' | translate }}</strong> {{ 'mainauth.privacy.s03ReservationText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s03PaymentLabel' | translate }}</strong> {{ 'mainauth.privacy.s03PaymentText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s03ContactLabel' | translate }}</strong> {{ 'mainauth.privacy.s03ContactText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s03UsageLabel' | translate }}</strong> {{ 'mainauth.privacy.s03UsageText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s03DeviceLabel' | translate }}</strong> {{ 'mainauth.privacy.s03DeviceText' | translate }}</li>
        </ul>
        <p><strong>{{ 'mainauth.privacy.s03SourceLabel' | translate }}</strong> {{ 'mainauth.privacy.s03SourceText' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s03MandatoryLabel' | translate }}</strong> {{ 'mainauth.privacy.s03MandatoryText' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s03LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s04">
        <div class="ds-card-header">
          <div class="ds-num">04</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s04Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s04Text1' | translate }}</p>
        <p>{{ 'mainauth.privacy.s04Text2' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s04LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s05">
        <div class="ds-card-header">
          <div class="ds-num">05</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s05Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s05Text1Pre' | translate }}<a href="https://www.okta.com/privacy-policy/" target="_blank" rel="noopener noreferrer">okta.com/privacy-policy</a>{{ 'mainauth.privacy.s05Text1Post' | translate }}</p>
        <p>{{ 'mainauth.privacy.s05Text2' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s05LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s06">
        <div class="ds-card-header">
          <div class="ds-num">06</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s06Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s06Text1' | translate }}</p>
        <p>{{ 'mainauth.privacy.s06Text2' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s06LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s07">
        <div class="ds-card-header">
          <div class="ds-num">07</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s07Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s07Text1' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s07SharedLabel' | translate }}</strong> {{ 'mainauth.privacy.s07SharedText' | translate }}</p>
        <p>{{ 'mainauth.privacy.s07Retention' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s07LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s08">
        <div class="ds-card-header">
          <div class="ds-num">08</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s08Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s08Text1' | translate }}</p>
        <p>{{ 'mainauth.privacy.s08Text2' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s08LegalBasis' | translate }}</p>
      </div>

      <!-- EU AI Act (Reg. (EU) 2024/1689) transparency — generally applicable from 02.08.2026 -->
      <div class="ds-card" id="ds-s09">
        <div class="ds-card-header">
          <div class="ds-num">09</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s09Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s09Intro' | translate }}</p>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s09ExtractionLabel' | translate }}</strong> {{ 'mainauth.privacy.s09ExtractionText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s09TranslationLabel' | translate }}</strong> {{ 'mainauth.privacy.s09TranslationText' | translate }}</li>
        </ul>
        <p><strong>{{ 'mainauth.privacy.s09RoleLabel' | translate }}</strong> {{ 'mainauth.privacy.s09RoleText' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s09NoTrainingLabel' | translate }}</strong> {{ 'mainauth.privacy.s09NoTrainingText' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s09HumanLabel' | translate }}</strong> {{ 'mainauth.privacy.s09HumanText' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s09NoBiometricLabel' | translate }}</strong> {{ 'mainauth.privacy.s09NoBiometricText' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s09LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s10">
        <div class="ds-card-header">
          <div class="ds-num">10</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s10Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s10Intro' | translate }}</p>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s10NoShowLabel' | translate }}</strong> {{ 'mainauth.privacy.s10NoShowText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s10DepositLabel' | translate }}</strong> {{ 'mainauth.privacy.s10DepositText' | translate }}</li>
        </ul>
        <p><strong>{{ 'mainauth.privacy.s10LogicLabel' | translate }}</strong> {{ 'mainauth.privacy.s10LogicText' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s10RightsLabel' | translate }}</strong> {{ 'mainauth.privacy.s10RightsText' | translate }} <a href="mailto:privacy@gastro-management.ch">privacy&#64;gastro-management.ch</a></p>
        <p><strong>{{ 'mainauth.privacy.s10NoProfilingLabel' | translate }}</strong> {{ 'mainauth.privacy.s10NoProfilingText' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s10LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s11">
        <div class="ds-card-header">
          <div class="ds-num">11</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s11Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s11Text1' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s11RemoteLabel' | translate }}</strong> {{ 'mainauth.privacy.s11RemoteText' | translate }}</p>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s11LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s12">
        <div class="ds-card-header">
          <div class="ds-num">12</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s12Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s12Intro' | translate }}</p>
        <ul>
          <li><strong>Microsoft Azure</strong> {{ 'mainauth.privacy.s12Azure' | translate }}</li>
          <li><strong>Auth0 / Okta</strong> {{ 'mainauth.privacy.s12Auth0' | translate }}</li>
          <li><strong>Stripe</strong> {{ 'mainauth.privacy.s12Stripe' | translate }}</li>
          <li><strong>AbaNinja (DeepCloud AG)</strong> {{ 'mainauth.privacy.s12AbaNinja' | translate }}</li>
          <li><strong>Azure AI Translator</strong> {{ 'mainauth.privacy.s12Translator' | translate }}</li>
          <li><strong>Azure OpenAI Service</strong> {{ 'mainauth.privacy.s12OpenAi' | translate }}</li>
          <li><strong>Cloudflare</strong> {{ 'mainauth.privacy.s12Cloudflare' | translate }}</li>
          <li><strong>Azure IoT Hub</strong> {{ 'mainauth.privacy.s12IotHub' | translate }}</li>
          <li><strong>Apple Push Notification service / Apple Wallet</strong> {{ 'mainauth.privacy.s12Apple' | translate }}</li>
          <li><strong>Google Firebase Cloud Messaging</strong> {{ 'mainauth.privacy.s12Fcm' | translate }}</li>
          <li><strong>Google Analytics 4</strong> {{ 'mainauth.privacy.s12Google' | translate }}</li>
        </ul>
        <p>{{ 'mainauth.privacy.s12Changes' | translate }}</p>
        <p>{{ 'mainauth.privacy.s12NoSale' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s13">
        <div class="ds-card-header">
          <div class="ds-num">13</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s13Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s13Intro' | translate }}</p>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s13EuLabel' | translate }}</strong> {{ 'mainauth.privacy.s13EuText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s13ChLabel' | translate }}</strong> {{ 'mainauth.privacy.s13ChText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s13UkLabel' | translate }}</strong> {{ 'mainauth.privacy.s13UkText' | translate }}</li>
        </ul>
        <p>{{ 'mainauth.privacy.s13Tia' | translate }}</p>
        <p>{{ 'mainauth.privacy.s13Copy' | translate }} <a href="mailto:privacy@gastro-management.ch">privacy&#64;gastro-management.ch</a></p>
      </div>

      <div class="ds-card" id="ds-s14">
        <div class="ds-card-header">
          <div class="ds-num">14</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s14Title' | translate }}</div>
        </div>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s14ContractLabel' | translate }}</strong> {{ 'mainauth.privacy.s14ContractText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s14EmployeeLabel' | translate }}</strong> {{ 'mainauth.privacy.s14EmployeeText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s14ReservationLabel' | translate }}</strong> {{ 'mainauth.privacy.s14ReservationText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s14ContactLabel' | translate }}</strong> {{ 'mainauth.privacy.s14ContactText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s14AuditLabel' | translate }}</strong> {{ 'mainauth.privacy.s14AuditText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s14TechLabel' | translate }}</strong> {{ 'mainauth.privacy.s14TechText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s14AccountLabel' | translate }}</strong> {{ 'mainauth.privacy.s14AccountText' | translate }}</li>
        </ul>
        <p>{{ 'mainauth.privacy.s14Criteria' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s15">
        <div class="ds-card-header">
          <div class="ds-num">15</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s15Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s15Intro' | translate }}</p>
        <ul>
          <li>{{ 'mainauth.privacy.s15Encryption' | translate }}</li>
          <li>{{ 'mainauth.privacy.s15Access' | translate }}</li>
          <li>{{ 'mainauth.privacy.s15Tenant' | translate }}</li>
          <li>{{ 'mainauth.privacy.s15Backup' | translate }}</li>
          <li>{{ 'mainauth.privacy.s15Audit' | translate }}</li>
        </ul>
        <p class="ds-legal-basis">{{ 'mainauth.privacy.s15LegalBasis' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s16">
        <div class="ds-card-header">
          <div class="ds-num">16</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s16Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s16Intro' | translate }}</p>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s16EssentialLabel' | translate }}</strong> {{ 'mainauth.privacy.s16EssentialPre' | translate }}<code>gm_cookie_consent</code>{{ 'mainauth.privacy.s16EssentialPost' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s16FunctionalLabel' | translate }}</strong> {{ 'mainauth.privacy.s16FunctionalPre' | translate }}<code>portal.lang</code>{{ 'mainauth.privacy.s16FunctionalPost' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s16AnalyticsLabel' | translate }}</strong> {{ 'mainauth.privacy.s16AnalyticsPre' | translate }}<code>_ga</code>, <code>_ga_*</code>{{ 'mainauth.privacy.s16AnalyticsPost' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s16SessionLabel' | translate }}</strong> {{ 'mainauth.privacy.s16SessionText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s16ExternalLabel' | translate }}</strong> {{ 'mainauth.privacy.s16ExternalText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s16AdminLabel' | translate }}</strong> {{ 'mainauth.privacy.s16AdminPre' | translate }}<code>portal.activeTenant</code>{{ 'mainauth.privacy.s16AdminPost' | translate }}</li>
        </ul>
        <p>{{ 'mainauth.privacy.s16Withdraw' | translate }}</p>
        <p>{{ 'mainauth.privacy.s16Signals' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s17">
        <div class="ds-card-header">
          <div class="ds-num">17</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s17Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s17Intro' | translate }}</p>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s17AccessLabel' | translate }}</strong> {{ 'mainauth.privacy.s17AccessText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s17RectifyLabel' | translate }}</strong> {{ 'mainauth.privacy.s17RectifyText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s17EraseLabel' | translate }}</strong> {{ 'mainauth.privacy.s17EraseText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s17RestrictLabel' | translate }}</strong> {{ 'mainauth.privacy.s17RestrictText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s17PortabilityLabel' | translate }}</strong> {{ 'mainauth.privacy.s17PortabilityText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s17ObjectLabel' | translate }}</strong> {{ 'mainauth.privacy.s17ObjectText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s17WithdrawLabel' | translate }}</strong> {{ 'mainauth.privacy.s17WithdrawText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s17HumanLabel' | translate }}</strong> {{ 'mainauth.privacy.s17HumanText' | translate }}</li>
        </ul>
        <p>{{ 'mainauth.privacy.s17Process' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s17TenantLabel' | translate }}</strong> {{ 'mainauth.privacy.s17TenantText' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s17DpaLabel' | translate }}</strong> {{ 'mainauth.privacy.s17DpaText' | translate }} <a href="mailto:privacy@gastro-management.ch">privacy&#64;gastro-management.ch</a></p>
        <a routerLink="/contact" class="ds-link">
          <ion-icon name="arrow-forward-outline"></ion-icon>
          {{ 'mainauth.privacy.s17ContactLink' | translate }}
        </a>
      </div>

      <!-- CCPA/CPRA + other US state privacy laws -->
      <div class="ds-card" id="ds-s18">
        <div class="ds-card-header">
          <div class="ds-num">18</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s18Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s18Intro' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s18NoSaleLabel' | translate }}</strong> {{ 'mainauth.privacy.s18NoSaleText' | translate }}</p>
        <p>{{ 'mainauth.privacy.s18RightsIntro' | translate }}</p>
        <ul>
          <li><strong>{{ 'mainauth.privacy.s18KnowLabel' | translate }}</strong> {{ 'mainauth.privacy.s18KnowText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s18DeleteLabel' | translate }}</strong> {{ 'mainauth.privacy.s18DeleteText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s18CorrectLabel' | translate }}</strong> {{ 'mainauth.privacy.s18CorrectText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s18OptOutLabel' | translate }}</strong> {{ 'mainauth.privacy.s18OptOutText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s18LimitLabel' | translate }}</strong> {{ 'mainauth.privacy.s18LimitText' | translate }}</li>
          <li><strong>{{ 'mainauth.privacy.s18AppealLabel' | translate }}</strong> {{ 'mainauth.privacy.s18AppealText' | translate }}</li>
        </ul>
        <p><strong>{{ 'mainauth.privacy.s18GpcLabel' | translate }}</strong> {{ 'mainauth.privacy.s18GpcText' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s18NonDiscrLabel' | translate }}</strong> {{ 'mainauth.privacy.s18NonDiscrText' | translate }}</p>
        <p><strong>{{ 'mainauth.privacy.s18AgentLabel' | translate }}</strong> {{ 'mainauth.privacy.s18AgentText' | translate }} <a href="mailto:privacy@gastro-management.ch">privacy&#64;gastro-management.ch</a></p>
        <p><strong>{{ 'mainauth.privacy.s18ShineLabel' | translate }}</strong> {{ 'mainauth.privacy.s18ShineText' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s19">
        <div class="ds-card-header">
          <div class="ds-num">19</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s19Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s19Text' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s20">
        <div class="ds-card-header">
          <div class="ds-num">20</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s20Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s20Text' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s21">
        <div class="ds-card-header">
          <div class="ds-num">21</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s21Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s21Text1Pre' | translate }}<strong>{{ 'mainauth.privacy.s21Edoeb' | translate }}</strong>{{ 'mainauth.privacy.s21Text1Post' | translate }}</p>
        <p>{{ 'mainauth.privacy.s21Address' | translate }} &nbsp;|&nbsp; <a href="https://www.edoeb.admin.ch" target="_blank" rel="noopener noreferrer">www.edoeb.admin.ch</a></p>
        <p>{{ 'mainauth.privacy.s21EuText' | translate }}</p>
        <p>{{ 'mainauth.privacy.s21UkText' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s22">
        <div class="ds-card-header">
          <div class="ds-num">22</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s22Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s22Text' | translate }}</p>
      </div>

      <div class="ds-card" id="ds-s23">
        <div class="ds-card-header">
          <div class="ds-num">23</div>
          <div class="ds-card-title">{{ 'mainauth.privacy.s23Title' | translate }}</div>
        </div>
        <p>{{ 'mainauth.privacy.s23Text' | translate }}</p>
      </div>

      <!-- Self-contained product policies (ScreenDeck, Chroniq). Always rendered, each
           as its own labelled section after the base — see product-legal.registry.ts. -->
      @for (product of productDocs; track product.key) {
      <div class="ds-card ds-card--product" [id]="product.key">
        <div class="ds-card-header">
          <div class="ds-num"><ion-icon name="business-outline"></ion-icon></div>
          <div class="ds-card-title">{{ product.doc.title }}</div>
        </div>
        <p class="ds-meta">{{ product.doc.meta }}</p>
      </div>
      @for (section of product.doc.sections; track section.num) {
      <div class="ds-card" [id]="sectionId(product.key, section.num)">
        <div class="ds-card-header">
          <div class="ds-num">{{ section.num }}</div>
          <div class="ds-card-title">{{ section.title }}</div>
        </div>
        <!-- Authored in this repository, never user input; Angular sanitises it regardless.
             .ds-card-body is what the ::ng-deep block in the stylesheet hooks onto — the
             component's own scoped rules cannot reach [innerHTML] nodes. -->
        <div class="ds-card-body" [innerHTML]="section.body"></div>
      </div>
      }
      }

      </div>
    </div>

    <!-- Footer note -->
    <div class="ds-footer">
      <ion-icon name="shield-checkmark-outline"></ion-icon>
      <span>{{ 'mainauth.privacy.footer' | translate }}</span>
    </div>

  </div>

  <!-- Outside .ds-page so it spans the full width like on the other marketing pages. -->
  <app-portal-footer></app-portal-footer>
</ion-content>
